<template>
<div>
  <Department
    :value.sync="value"
    :person="false"
  />
  </div>
  
</template>

<script>
import { ROLE } from "@/modules/entities";
import { getBasicInfo } from "@/modules/user";
import Department from "@/components/Department";


export default {
  name: "departmentcomponent",
  components: { Department },
  data() {
    const userBasicInfo = getBasicInfo();
    return {
      ROLE,
      userBasicInfo,
      value:''
    };
  },
  props: {
    item: {},
  },
  mounted() {
    var popper = document.querySelector(".el-popper");
    popper.parentNode.removeChild(popper);
  },
  watch:{
    value(value){
       this.$emit("update:item", value);
    },
    item(){
      if(!this.item){
        this.value = ''
      }
    }
  },
  methods: {
    show() {
      if (
        [
          ROLE.FRONT_MANAGER,
          ROLE.BACK_DIRECTOR,
          ROLE.FRONT_DIRECTOR,
          ROLE.COMPLIANCE,
        ].includes(this.userBasicInfo.role)
      ) {
        if (this.content) {
          this.visable = true;
        } else {
          this.visable = false;
        }
      } else {
        this.visable = false;
      }
    },
  },
};
</script>

<style lang="scss">
.popver {
  // background: brown;
  .el-popper {
    // visibility: hidden;
  }
}
</style>